import { render } from "./LandInfo.vue?vue&type=template&id=2407db6d"
import script from "./LandInfo.vue?vue&type=script&lang=js"
export * from "./LandInfo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\investmap\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__